import React, {Component} from 'react';
import { Row, Col, InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Form, FormGroup,  FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/ShortText';
import NavigationIcon from '@material-ui/icons/Navigation';
import TextField from '@material-ui/core/TextField';
import { Badge } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';


const styles = theme => ({
  fab: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
});

class OffeneFragen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: '', 
      starquestions: []
    };

    this.handleChange = this.handleChange.bind(this)
    this.addStarQuestion = this.addStarQuestion.bind(this)
    this.deleteStarQuestion = this.deleteStarQuestion.bind(this)

  }

  handleChange(e) {
    this.setState({
      question: e.target.value,
    });
  };
	
  
async addStarQuestion(){

  var localsq = this.state.starquestions;
  localsq.push(this.state.question)

await  this.setState({
    starquestions: localsq
  })

  this.props.callback(localsq)

}


async deleteStarQuestion(questiontext){
  console.log('NOW IN STARQUESTION with questiontext ', questiontext)
  var localsq = this.state.starquestions;
  localsq = localsq.filter( f => f != questiontext)

await  this.setState({
    starquestions: localsq
  })

  this.props.callback(localsq)
}

  render() {
        
    const classes = this.props;
	  
    return (
      <div>
<Container>
  <Row> 
    <Col>
<TextField
          id="outlined-multiline-flexible"
          label="Definieren Sie Ihre offene Frage als Text"
          multiline
          rowsMax="4"
          value={this.state.multiline}
          onChange={this.handleChange}
          className={classes.textField}
          margin="normal"
          helperText="Fragendefinition für offene Fragen für den Beantworter"
          variant="outlined"
        />
 
        </Col>
        <Col>

        <Fab color="primary" aria-label="Add" className={classes.fab}>
        <AddIcon onClick={this.addStarQuestion}/>
      </Fab>    
       
</Col>
</Row>
</Container>

{
  

              this.state.starquestions ? ( <Container> {this.state.starquestions.map(question =>
              <Row>
                <Col>
                <Badge> {question} </Badge>
                </Col>
                <Col>
                <Fab color="primary" aria-label="Add" className={classes.fab}>
                    <DeleteIcon onClick={() => {
                      this.deleteStarQuestion(question)
                      console.log('Question is: ', question)
                    }
                     } />
                  </Fab>
                  </Col>
                </Row>
              )}
                </Container>
                
              ) : null

            }
      

      </div>
    );
  }
}

export default withStyles(styles)(OffeneFragen);




// WEBPACK FOOTER //
// ./src/modules/movie-browser/OffeneFragen.js